export { requestDetailsRoute } from './routes';
